import React, {useEffect, useRef, useState} from 'react'
import {useSelector} from 'react-redux'
import axios from 'axios'
import Cookies from 'js-cookie'

import * as constants from 'constants/index.js'
import CardsHeader from 'layouts/Headers/CardsHeader.js'

import InputCustom from 'views/pages/components/InputCustom'
import TableCustom from 'views/pages/components/TableCustom'

import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    FormGroup,
    Modal,
    Row,
    UncontrolledDropdown,
} from 'reactstrap'

import {deletee, hasPermission, update,} from 'views/policies/ResourceTypePolicy';

import {manageItems,} from 'views/policies/UserPolicy';

import notify from '@utils/notify';

export default function ResourceTypes() {
  const permissions = useSelector(state => state.getState).permissions

  const [token, setToken] = useState('')
  const [loading, setLoading] = useState(true)
  const [items, setItems] = useState([])
  const [statuses, setStatuses] = useState([])

  const [editModal, setEditModal] = useState({
    show: false,
    header: '',
    division: ''
  })
  const [resourceType, setResourceType] = useState('')

  const [deleteModal, setDeleteModal] = useState({
    show: false,
    header: '',
    body: '',
    onClick: null
  })

  const [errors, setErrors] = useState('')

  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()

    const fetchData = async () => {
      try {
        const response = await axios({
          method: 'GET',
          url: `${constants.API_URL}/resource-types`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        console.log('response :: ', response.data)
        const data = response.data
        setItems(data.data.items)
        setStatuses(data.data.statuses)

        setTimeout(() => {
          setLoading(false)
        }, 500);
      } catch (error) {
        setLoading(false)
        if (axios.isCancel(error)) {
          console.log('Request canceled :: ', error)
        } else {
          console.error('error :: ', error)
          notify.warning('Warning', error.response ? error.response.statusText : 'Error occurred!')
        }
      }
    }

    fetchData()

    return () => {
      source.cancel()
    }
  }, [])

  const addResourceType = async () => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${constants.API_URL}/resource-types`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: resourceType
      })
      console.log('response :: ', response.data)
      const data = response.data
      setItems(data.data.items)
      
      setEditModal({
        ...editModal,
        show: false
      })
      setErrors('')
      notify.success(data.message)
    } catch (error) {
      setErrors('')
      console.error('error :: ', error)
      if (error.response && error.response.status === 422) {
        setErrors(error.response.data.errors)
        return
      }
      setEditModal({
        ...editModal,
        show: false
      })
      notify.warning(error.response ? error.response.statusText : 'Error occurred!')
    }
  }

  const updateResourceType = async () => {
    try {
      const response = await axios({
        method: 'PUT',
        url: `${constants.API_URL}/resource-types/${resourceType.id}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: resourceType
      })
      console.log('response :: ', response.data)
      const data = response.data
      setItems(data.data.items)
      
      setEditModal({
        ...editModal,
        show: false
      })
      setErrors('')
      notify.success(data.message)
    } catch (error) {
      setErrors('')
      console.error('error :: ', error)
      if (error.response && error.response.status === 422) {
        setErrors(error.response.data.errors)
        return
      }
      setEditModal({
        ...editModal,
        show: false
      })
      notify.warning(error.response ? error.response.statusText : 'Error occurred!')
    }
  }

  const deleteResourceType = async (resourceTypeId) => {
    try {
      const response = await axios({
        method: 'DELETE',
        url: `${constants.API_URL}/resource-types/${resourceTypeId}`,
        headers: {
          Authorization: `Bearer ${token}`,
        }
      })
      console.log('response :: ', response.data)
      const data = response.data
      setItems(data.data.items)
      
      setDeleteModal({
        ...deleteModal,
        show: false
      })
      notify.success(data.message)
    } catch (error) {
      console.error('error :: ', error)
      setDeleteModal({
        ...deleteModal,
        show: false
      })
      notify.warning(error.response ? error.response.statusText : 'Error occurred!')
    }
  }

  return (
    <>
      <CardsHeader name="Resources" parentName="Resource Type Management" currentName="List" />
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <div className="d-flex justify-content-between">
                  <div>
                    <h1 className="title">Resource Types</h1>
                    <p className="text-sm mb-0">You can manage Resource Types.</p>
                  </div>
                  {hasPermission(permissions, 'create-resource-types') &&
                    <Button className="h-50" color="success" type="button" onClick={() => {
                      setResourceType('')
                      setEditModal({
                        show: true,
                        header: 'Resource type information',
                        division: 'create'
                      })
                    }}>Add resource types</Button>}
                </div>
              </CardHeader>
              <CardBody>
                <TableCustom
                  loading={loading}
                  items={items}
                  columns={[
                    {
                      dataField: "name",
                      text: "Name"
                    },
                    {
                      dataField: "is_active",
                      text: "Status",
                      formatter: (rowContent, row) => {
                        return statuses[row.is_active ? 1 : 0]
                      }
                    },
                    {
                      dataField: "",
                      text: "Active",
                      style: {
                        textAlign: 'right',
                        display: manageItems(permissions) ? 'block' : 'none'
                      },
                      headerStyle: {
                        display: manageItems(permissions) ? 'block' : 'none'
                      },
                      formatter: (rowContent, row) => {
                        return (
                          <>
                            {(hasPermission(permissions, 'update-resource-types') || hasPermission(permissions, 'delete-resource-types')) &&
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  className="btn-icon-only text-light"
                                  color=""
                                  role="button"
                                  size="sm"
                                >
                                  <i className="fas fa-ellipsis-v" />
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-arrow" right>
                                  {update(permissions, row) &&
                                    <DropdownItem
                                      onClick={() => {
                                        setResourceType({
                                          ...row,
                                          is_active: row.is_active === true? 1: 0
                                        })
                                        setEditModal({
                                          show: true,
                                          header: 'Resource type information',
                                          division: 'update'
                                        })
                                      }}
                                    >
                                      Edit
                                </DropdownItem>}
                                  {deletee(permissions, row) &&
                                    <DropdownItem
                                      onClick={() => setDeleteModal({
                                        show: true,
                                        header: 'Delete resource type',
                                        body: 'Are you sure you want to delete this resource type?',
                                        onClick: () => deleteResourceType(row.id)
                                      })}
                                    >
                                      Delete
                                </DropdownItem>}
                                </DropdownMenu>
                              </UncontrolledDropdown>}
                          </>
                        )
                      }
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          isOpen={editModal.show}
          toggle={() => setEditModal({
            ...editModal,
            show: false
          })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title">{editModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setEditModal({
                ...editModal,
                show: false
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <InputCustom
              label={`Name`}
              placeholder={`Name`}
              value={resourceType && resourceType.name ? resourceType.name : ''}
              onChange={e => setResourceType({
                ...resourceType,
                name: e.target.value
              })}
              invalid={errors && errors.name ? true : false}
              errorMessage={errors.name}
            />
            <InputCustom
              type={`number`}
              label={`Order in menu list`}
              value={resourceType && resourceType.sort ? resourceType.sort : ''}
              onChange={e => setResourceType({
                ...resourceType,
                sort: e.target.value
              })}
              invalid={errors && errors.sort ? true : false}
              errorMessage={errors.sort}
            />
            <FormGroup>
              <label className="form-control-label">{`Status`}</label>
              {statuses && statuses.length > 0 &&
                statuses.map((status, index) => {
                  return (
                    <div className="custom-control custom-radio" key={index}>
                      <input
                        className="custom-control-input"
                        id={`customRadio${index}`}
                        name="customRadio"
                        type="radio"
                        checked={resourceType && index === resourceType.is_active? true: false}
                        onChange={() => setResourceType({
                          ...resourceType,
                          is_active: index
                        })}
                      />
                      <label className="custom-control-label" htmlFor={`customRadio${index}`}>
                        {status}
                      </label>
                    </div>
                  )
                })
              }
              <div className="invalid-feedback" style={{display: errors && errors.is_active? 'block': 'none'}}>
                {errors.is_active}
              </div>
            </FormGroup>
          </div>
          <div className="modal-footer">
            <Button
              className="new-event--add"
              color="primary"
              type="button"
              onClick={() => editModal.division === 'update' ? updateResourceType() : addResourceType()}
            >
              {`Save`}
            </Button>
            <Button
              className="ml-auto"
              color="link"
              type="button"
              onClick={() => setEditModal({
                ...editModal,
                show: false
              })}
            >
              {`Close`}
            </Button>
          </div>
        </Modal>
        <Modal
          isOpen={deleteModal.show}
          toggle={() => setDeleteModal({
            ...deleteModal,
            show: false
          })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title">{deleteModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setDeleteModal({
                ...deleteModal,
                show: false
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            {deleteModal.body}
          </div>
          <div className="modal-footer">
            <Button
              className="new-event--add"
              color="danger"
              type="button"
              onClick={deleteModal.onClick}
            >
              {`Delete`}
            </Button>
            <Button
              className="ml-auto"
              color="link"
              type="button"
              onClick={() => setDeleteModal({
                ...deleteModal,
                show: false
              })}
            >
              {`Close`}
            </Button>
          </div>
        </Modal>
      </Container>
    </>
  )
}